module.exports = __webpack_public_path__ + "static/media/logo-brother.8d4a7fc7.svg";